<app-loading class="loading" size=".5" *ngIf="loading" color="var(--primary-sec-color)"></app-loading>
<ng-container *ngIf="!loading">
    <div class="container" *ngIf="(vehicleDetails?.vin || vehicleDetails?.make);else empty">
        <section class="vehicle-details">
            <div class="model-year-vin">
                <div class="desc">
                    <mat-icon style="cursor: pointer;" (click)="backToDashboard()">arrow_back_ios</mat-icon>
                    <span class="service-history-title">
                        {{'service.serviceHistoryOf' | translate}} {{vehicleDetails?.description | titlecase}}
                    </span>
                </div>
                <div class="model-details">
                    <div class="model">{{vehicleDetails?.make  | titlecase }} {{vehicleDetails?.model}} {{vehicleDetails?.year}}</div>
                    <div class="vin">VIN {{vehicleDetails?.vin}}</div>
                </div>
            </div>

            <select class="choose-vehicle" *ngIf="(userVehicleDetails$ | async).length > 1" (change)="onVehicleSelect($event.target.value)">
                <option disabled selected>{{ 'testDrive.selectDifferentVehicle' | translate}}</option>
                <option *ngFor="let vehicle of (userVehicleDetails$ | async)" [value]="vehicle.vin">
                   <span *ngIf="vehicle.make"> {{vehicle.make}} {{vehicle.model}} {{vehicle.year}}</span>
                   <span *ngIf="!vehicle.make">{{vehicle.vin}} </span>
                </option>
            </select>
        </section>

        <section class="history-details" *ngIf="(userVehicleDetails$ | async).length && !errorMessage; else empty">
            <mat-expansion-panel *ngFor="let history of serviceHistory">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{history.repairOrderCloseDate | date}}
                    </mat-panel-title>
                    <mat-panel-description>
                        {{history.mileage}} {{mileageUnit}}
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="condition-details">
                    <div class="service-details">
                        <span class="ro-number">
                            <span class="header">{{'service.repairOrder' | translate}} #:</span>
                            <span>{{history.repairOrderNumber}}</span>
                        </span>
                        <span class="dealer">
                            <span class="header">{{'service.servicingDealer' | translate}}:</span>
                            <span>{{history.dealerNumber}}</span>
                        </span>
                        <span class='ro-open'>
                            <span class="header">{{'service.openDate' | translate}}:</span>
                            <span>{{history.repairOrderOpenDate | date}}</span>
                        </span>
                        <span class='ro-close'>
                            <span class="header">{{'service.closeDate' | translate}}:</span>
                            <span>{{history.repairOrderCloseDate | date}}</span>
                        </span>
                        <span class='advisor'>
                            <span class="header">{{ 'generalSettings.serviceAdvisor' | translate}}</span>
                            <span>{{history.serviceAdvisor}}</span>
                        </span>
                    </div>

                    <div class="conditions" *ngFor="let condition of history.repairOrderConditions">
                        <span class="condition">{{'service.condition' | translate}} {{condition.conditionNumber}}</span>
                        <span class="operation">
                            <span
                                *ngFor="let operation of condition.operation">{{operation.serviceOperationDescription}}</span>
                        </span>
                    </div>
                </div>
            </mat-expansion-panel>
        </section>
    </div>
    <ng-template #empty>
        <div class="history-not-found">
            <mat-icon class="icon">info</mat-icon>
            <div class="text">{{ 'otherTexts.serviceHistoryNotFound' | translate}}</div>
            <div class="text-sec">
                {{ 'otherTexts.thereAreNoServiceHistoryAssociatedWithTheVehicle' | translate}}.
            </div>
          </div>
    </ng-template>
</ng-container>
